import React from 'react';
import Footer from './Footer';

const Legal: React.FC = () => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Legal Notice</h1>
      <p>
        The information provided on this website is for general informational purposes only. All information on the Site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the Site.
      </p>
      <p>
        Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.
      </p>
      <h2>Intellectual Property</h2>
      <p>
        All content, trademarks, service marks, logos, and images are the property of their respective owners. Unauthorized use, reproduction, or distribution of any material from this site is strictly prohibited.
      </p>
      <h2>External Links</h2>
      <p>
        The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through the site.
      </p>
      <h2>Changes to This Legal Notice</h2>
      <p>
        We reserve the right to update or change this legal notice at any time. Any changes will be posted on this page.
      </p>
      <h2>Contact</h2>
      <p>
        If you have any questions regarding this legal notice, please contact us through the information provided on the Contact page.
      </p>
    </div>
    <Footer />
  </div>
);

export default Legal; 